import { Environment } from "../app/interfaces";

export const environment: Environment = {
  production: true,
  name: "staging",
  host: "s.admin.jericommerce.com",
  release: "2026.11.03-1046",
  apiUrl: "https://s.api.jericommerce.com",
  webAppUrl: "https://s.jeri.link",
  firebaseConfig: {
    apiKey: "AIzaSyCWeh4e6mYRs2V4js3pYU1uF7piIYbvk_g",
    authDomain: "jeripass-admin-app.firebaseapp.com",
    projectId: "jeripass-admin-app",
    storageBucket: "jeripass-admin-app.appspot.com",
    messagingSenderId: "958153644094",
    appId: "1:958153644094:web:431a4a1bfa170e837d196f",
  },
  shopifyClientId: "c644438bf56ca0dc3bac2c72f885aa6e",
  shopifyAppName: "jeripass-admin-staging",
};
